import { DependencyList } from 'react';
import { useBFCacheLifecycle } from './use-page-lifecycle-effect';
import type { CommonLifecycleOptions } from './page-lifecycle-types';

export type PageRestoreEffectOptions = CommonLifecycleOptions;

/**
 * Lightweight helper for BFCache freeze/restore events. Use this when you only
 * need to respond to `pageshow`/`pagehide` without observability features.
 *
 * This hook does not accept labels or tags, and instrumentation is always
 * disabled. No telemetry events are emitted, no timeouts are enforced, and no
 * AbortController plumbing is created.
 *
 * For advanced scenarios (observability, timeout enforcement, telemetry tags),
 * use `usePageLifecycleEffect` instead.
 */
export const usePageRestoreEffect = (
  options: PageRestoreEffectOptions,
  deps: DependencyList,
) => {
  useBFCacheLifecycle(
    {
      ...options,
      instrumentation: 'none',
    },
    deps,
  );
};
